import { useQuery, QueryHookOptions, OperationVariables, DocumentNode } from '@apollo/client';
import { useEffect } from 'react';

interface UseGraphQLQueryOptions<TData, TVariables extends OperationVariables> 
  extends QueryHookOptions<TData, TVariables> {
  showErrorToast?: boolean;
  errorMessage?: string;
}

export function useGraphQLQuery<TData = any, TVariables extends OperationVariables = OperationVariables>(
  query: DocumentNode,
  options?: UseGraphQLQueryOptions<TData, TVariables>
) {
  const { showErrorToast = true, errorMessage, ...queryOptions } = options || {};
  
  const result = useQuery<TData, TVariables>(query, queryOptions);
  
  useEffect(() => {
    if (result.error && showErrorToast) {
      const message = errorMessage || result.error.message || 'Failed to fetch data';
      console.error('[GraphQL Query Error]:', message);
      // Toast will be implemented by consuming apps
    }
  }, [result.error, showErrorToast, errorMessage]);
  
  return result;
}
